"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const TicketModal_1 = require("./TicketModal");
class Ticket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false
        };
        this.showTicketDetail = () => {
            this.setState({ openModal: true });
        };
        this.onClose = () => {
            this.setState({ openModal: false });
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { bannerId, bannerMobileId } = this.props;
        const { image, movieTitle, startTime } = this.props.ticket;
        const poster = image ? image : "https://mf.dx.no/movie_placeholder.png?w=280&h=385&fit=crop&auto=compress";
        return (React.createElement("div", { className: "my-ticket" },
            React.createElement("div", { className: "ticket-card", onClick: this.showTicketDetail },
                React.createElement("div", { className: `ticket-card-content` },
                    React.createElement("div", { className: "title" }, movieTitle),
                    React.createElement("div", { className: "time" }, moment(startTime).format("hh:mm")),
                    React.createElement("div", { className: "date" }, moment(startTime).format("DD. MMMM YYYY"))),
                React.createElement("div", { className: "ticket-card-image", style: { backgroundImage: `url(${poster})` } })),
            React.createElement(TicketModal_1.default, { onClose: this.onClose, onRequestClose: this.onClose, ticket: this.props.ticket, bannerId: bannerId, bannerMobileId: bannerMobileId, isModalOpen: this.state.openModal })));
    }
}
exports.Ticket = Ticket;
exports.default = Ticket;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-my-page/Ticket.tsx